import { QueryClient } from '@tanstack/react-query';
import { WorkpayApiError } from '@/lib/apiEnvelope';

/**
 * Retry only transient failures: synthetic network code (0), universal server
 * errors (5xxx), and api-gateway upstream/proxy/unavailable failures
 * (48520–48539). Never retry 4xxx universal or domain (41xxx–47xxx) codes —
 * those are permanent.
 */
function isRetryable(error: WorkpayApiError): boolean {
  if (error.code === 0) return true;
  if (error.code >= 5000 && error.code < 6000) return true;
  if (error.code >= 48520 && error.code < 48540) return true;
  return false;
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0, // Always refetch on mount
      gcTime: 5 * 60 * 1000, // 5 minutes (garbage collection)
      retry: (failureCount, error) => {
        if (error instanceof WorkpayApiError && isRetryable(error)) {
          return failureCount < 1;
        }
        return false;
      },
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
